<template>
  <div
    id="user-details"
    class="no-shrink"
    :class="{hide: hideDetails}">
    <ContactDetails
      v-if="section === 'info'"/>
    <UserNotes
      v-if="section === 'notes'"/>
    <UserProperties
      v-if="section === 'properties'"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ContactDetails from './ContactDetails';
import UserNotes from './UserNotes';
import UserProperties from './UserProperties';

export default {
  name: 'UserDetails',
  components: {
    ContactDetails,
    UserNotes,
    UserProperties,
  },
  props: {
    section: {
      type: String,
      required: true,
    },
    conversation: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      hideDetails: false,
    };
  },
  computed: {
    ...mapGetters({
      // activeConversation: 'chat/activeConversation',
    }),
  },
  watch: {
    // activeConversation(newConversation) {
    //   console.log(newConversation);
    // },
    conversation(conversation) {
      if (!this.$lodash.isEmpty(conversation)) {
        if (!conversation.contact.details_loaded) {
          this.fetchContact({
            // merchant_id: this.$route.params.merchant_id, // load from conversation, not route
            merchant_id: conversation.business_id,
            contact_id: conversation.contact.id,
          });
        } else {
          this.contact = conversation.contact;
        }
      }
    },
  },
  mounted() {
    // ChatEventBus.$on('test', this.toggler);
  },
  beforeDestroy() {
    // console.log('destroyed');
    // ChatEventBus.$off('test', this.toggler);
  },
  methods: {
    ...mapActions({
      fetchContact: 'contact/fetchContact',
    }),
    /**
     * Toggles the column with an animation.
     */
    toggle() {},
    toggler(payload) {
      // console.log('TOGGLING 2222222: ', payload);
      this.hideDetails = !this.hideDetails;
    },
  },
};
</script>

<style lang="scss" scoped>
// TODO animation via vue animation so the remove is not cut off. Visible when played in 10% speed
#user-details {
  background-color: $greyUltralight;
  width: $detailsSidebarWidth;
  transition: .1s all;
  overflow: hidden;
  box-shadow: -1px 0 $greyBorderSecondary;
  z-index: 900;

  h3 {
    margin: 18px 15px 15px;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.05;
    color: $blackPrimary;
  }

  &.hide {
    width: 0;
  }
}
</style>
